import React, { useState, useEffect } from 'react';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import DeptMaster from "./scenes/Masters/DeptMaster";
import InternalDeptMaster from "./scenes/Masters/InternalDeptMaster";
import ProdFormulaMaster from "./scenes/Masters/ProdFormulaMaster";
import QualityCheckMaster from "./scenes/Masters/QualityCheckMaster";
import QualityCheckEntry from "./scenes/transaction/QualityCheckEntry";
import DesignationMaster from "./scenes/Masters/DesignationMaster";
import GSTRatesMaster from "./scenes/Masters/GSTRatesMaster";
import ItemCategoryMaster from "./scenes/Masters/ItemCategoryMaster";
import ItemGroupMaster from "./scenes/Masters/ItemGroupMaster";
import ItemMaster from "./scenes/Masters/ItemMaster";
import ItemSubGroupMaster from "./scenes/Masters/ItemSubGroupMaster";
import LocationMaster from "./scenes/Masters/LocationMaster";
import LedgerMaster from "./scenes/Masters/LedgerMaster";
import NarrationMaster from "./scenes/Masters/NarrationMaster";
import PackingMaster from "./scenes/Masters/PackingMaster";
import SubLedgerMaster from "./scenes/Masters/SubLedgerMaster";
import StateMaster from "./scenes/Masters/StateMaster";
import SubLedgerGroupMaster from "./scenes/Masters/SubLedgerGroupMaster";
import UnitMaster from "./scenes/Masters/UnitMaster";
import AcGroupMaster from "./scenes/Masters/AcGroupMaster";
import SellEntry from './scenes/transaction/SellEntry';
import CompanyMaster from './scenes/Masters/CompanyMaster';
import YearMaster from './scenes/Masters/YearMaster';
import StatusMaster from './scenes/Masters/StatusMaster';
import SettingMaster from './scenes/Masters/SettingMaster';
import VehicleMaster from './scenes/Masters/VehicleMaster';
import Packing from './scenes/transaction/Packing';
import DigitMaster from './scenes/Masters/DigitMaster';
import EmployeeMaster from './scenes/Masters/EmployeeMaster';
import GradeMaster from './scenes/Masters/GradeMaster';
import NatureMaster from './scenes/Masters/NatureMaster';
import ProcessMaster from './scenes/Masters/ProcessMaster';
import RejectionMaster from './scenes/Masters/RejectionMaster';
import ItemRateChartMaster from './scenes/Masters/ItemRateChartMaster';
import YojanaMaster from './scenes/Masters/YojanaMater';
import Dashboard from './scenes/global/Dashboard';
import ReportData from './scenes/reports/ReportData';
import ProdReport from './scenes/reports/ProdReport';
import MonthWiseProd from './scenes/reports/MonthWiseProd';
import NewSellEntry from './scenes/transaction/NewSellEntry';
import Production from './scenes/transaction/Production';
import RejwiseProd from './scenes/reports/RejwiseProd';
import LoginForm from "../src/Login";
import SelectForm from '../src/Select';
import { ColorModeContext, useMode } from "./theme";
import UserComponent from "./scenes/createuser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import axios from 'axios';


function App() {
  const [theme, colorMode] = useMode();
  const [searchQuery, setSearchQuery] = useState('');
  const [isAuthenticated, setisAuthenticated] = useState(false);
  const [selected, setSelected] = useState('');
  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedDept, setselectedDept] = useState('');
  const [selectState, setselectState] = useState('');
  const [isMasterEdit, setIsMasterEdit] = useState(true);
  const [isEntryEdit, setIsEntryEdit] = useState(true);
  const [isMasterAdd, setMasterAdd] = useState(true);
  const [isEntryAdd, setEntryAdd] = useState(true);
  const [isMasterDelete, setMasterDelete] = useState(true);
  const [isEntryDelete, setEntryDelete] = useState(true);
  const [isAdmin, setAdmin] = useState(false);
  const [yearMasterEntries, setYearMasterEntries] = useState([]);
  const [name, setName] = useState('');
  const location = useLocation();
  const [users, setUsers] = useState([]);

  const fetchUsers = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/getusers');
      setUsers(response.data);
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const fetchYearMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/year_master');
      setYearMasterEntries(response.data);
    } catch (error) {
      console.log('error:', error);
    }
  };

  /* useEffect(() => {
    fetchUsers();
    if (name) {
      const user = users.find(user => user.UserName === name);
      //console.log("canEdit user",user);
      if (user) { 
        if (user.AllowMasterEdit == 1) {
          setIsMasterEdit(true);
        }
        if (user.AllowMasterAdd == 1) {
          setMasterAdd(true);
        }
        if (user.AllowMasterDelete == 1) {
          setMasterDelete(true);
        }

        if (user.AllowEntryEdit == 1) {
          setIsEntryEdit(true);
        }
        if (user.AllowEntryAdd == 1) {
          setEntryAdd(true);
        }
        if (user.AllowEntryDelete == 1) {
          setEntryDelete(true);
        }
        if (user.Administrator == 1) {
          setAdmin(true);
        } else {
          setAdmin(false); 
        }

      } else {
        console.log("User not found for name:", name);
      }
    }
  }, [name]);  */

 useEffect(() => {
  fetchUsers().then(data => {
    if (data && Array.isArray(data)) {
      setUsers(data);
    }
  });
}, []); // load once on mount

useEffect(() => {
  if (name && users.length > 0) {
    const user = users.find(user => user.UserName === name);
    //console.log("canEdit user", user);
    if (user) {
      setIsMasterEdit(user.AllowMasterEdit == 1);
      setMasterAdd(user.AllowMasterAdd == 1);
      setMasterDelete(user.AllowMasterDelete == 1);
      setIsEntryEdit(user.AllowEntryEdit == 1);
      setEntryAdd(user.AllowEntryAdd == 1);
      setEntryDelete(user.AllowEntryDelete == 1);
      setAdmin(user.Administrator == 1);
    } else {
      console.log("User not found for name:", name);
    }
  }
}, [name, users]);
  
  const handleSearch = (searchQuery) => {
    setSearchQuery(searchQuery);
  };

  const handleLoginSuccess = (loggedInName) => {
    setisAuthenticated(true);
    setSearchQuery(''); // Clear search query on login
    setName(loggedInName);
  };

  const handleLogout = () => {
    setisAuthenticated(false);
    setSearchQuery(''); // Clear search query on logout
    setName('');
    setSelectedCompany('');
    setSelectedYear('');
    setselectedDept('');
    setselectState('');
  };

  const handleSelectFormSubmit = (company, year, dept, state) => {
    setSelectedCompany(company);
    setSelectedYear(year);
    setselectedDept(dept);
    setselectState(state);
  };
  /* 
     https://images.pexels.com/photos/16456724/pexels-photo-16456724/free-photo-of-forgeing-by-sternsteiger.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2
  https://pactsoft.com/india/assets/images/product-page/Best-ERP-Software-for-Medium-Businesses-in-India.jpg
     */
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app" style={{ backgroundImage: isAuthenticated ? 'none' : `url('https://images.wallpaperscraft.com/image/single/lines_stripes_blurred_112742_3840x2160.jpg')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
          {isAuthenticated && <Sidebar handleLogout={handleLogout} name={name} selectedCompany={selectedCompany} selectedYear={selectedYear} selectedDept={selectedDept} />}
          <main className="content" style={{ marginLeft: isAuthenticated ? '5%' : 0 }}>
            {isAuthenticated ? (
              <>
                {!(location.pathname === "/SelectCompany") && (
                  <Topbar
                    admin={isAdmin}
                    onSearch={handleSearch} name={name}
                    selectedCompany={selectedCompany}
                    selectedYear={selectedYear}
                    selectedDept={selectedDept}
                    handleLogout={handleLogout} />
                )}
                <Routes>
                  <Route path="/AcGroupMaster" element={<AcGroupMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/CompanyMaster" element={<CompanyMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/YearMaster" element={<YearMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/EmployeeMaster" element={<EmployeeMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/DeptMaster" element={<DeptMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/InternalDeptMaster" element={<InternalDeptMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/ProdFormulaMaster" element={<ProdFormulaMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/QualityCheckMaster" element={<QualityCheckMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/DesignationMaster" element={<DesignationMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/GSTRatesMaster" element={<GSTRatesMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/ItemCategoryMaster" element={<ItemCategoryMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/ItemGroupMaster" element={<ItemGroupMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/ItemMaster" element={<ItemMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/ItemSubGroupMaster" element={<ItemSubGroupMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/LedgerMaster" element={<LedgerMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/LocationMaster" element={<LocationMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/NarrationMaster" element={<NarrationMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/PackingMaster" element={<PackingMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/StateMaster" element={<StateMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/SubLedgerGroupMaster" element={<SubLedgerGroupMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/SubLedgerMaster" element={<SubLedgerMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/SettingMaster" element={<SettingMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/VehicleMaster" element={<VehicleMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/DigitMaster" element={<DigitMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/GradeMaster" element={<GradeMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/NatureMaster" element={<NatureMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/StatusMaster" element={<StatusMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/UnitMaster" element={<UnitMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/ProcessMaster" element={<ProcessMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/RejectionMaster" element={<RejectionMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/ItemRateChartMaster" element={<ItemRateChartMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/YojanaMaster" element={<YojanaMaster searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/Dashboard" element={<Dashboard searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />

                  <Route path="/createuser" element={<UserComponent searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} />} />
                  <Route path="/SellEntry" element={<SellEntry searchQuery={searchQuery} name={name} canEdit={isMasterEdit} canAdd={isMasterAdd} canDelete={isMasterDelete} selectedCompany={selectedCompany} selectedYear={selectedYear} selectedDept={selectedDept} selectState={selectState} />} />
                  <Route path="/QualityCheckEntry" element={<QualityCheckEntry searchQuery={searchQuery} name={name} canEdit={isEntryEdit} canAdd={isEntryAdd} canDelete={isEntryDelete} selectedCompany={selectedCompany} selectedYear={selectedYear} selectedDept={selectedDept} />} />
                  <Route path="/NewSellEntry" element={<NewSellEntry searchQuery={searchQuery} name={name} canEdit={isEntryEdit} canAdd={isEntryAdd} canDelete={isEntryDelete} selectedCompany={selectedCompany} selectedYear={selectedYear} selectedDept={selectedDept} selectState={selectState} />} />
                  <Route path="/Production" element={<Production searchQuery={searchQuery} name={name} canEdit={isEntryEdit} canAdd={isEntryAdd} canDelete={isEntryDelete} selectedCompany={selectedCompany} selectedYear={selectedYear} selectedDept={selectedDept} selectState={selectState} />} />

                  <Route path="/Packing" element={<Packing searchQuery={searchQuery} name={name} canEdit={isEntryEdit} canAdd={isEntryAdd} canDelete={isEntryDelete} selectedCompany={selectedCompany} selectedYear={selectedYear} selectedDept={selectedDept} selectState={selectState} />} />
                  <Route path="/ReportData/:endpoint" element={<ReportData searchQuery={searchQuery} name={name} canEdit={isEntryEdit} canAdd={isEntryAdd} canDelete={isEntryDelete} selectedCompany={selectedCompany} selectedYear={selectedYear} selectedDept={selectedDept} selectState={selectState} />} />
                  <Route path="/ProdReport/:endpoint" element={<ProdReport searchQuery={searchQuery} name={name} canEdit={isEntryEdit} canAdd={isEntryAdd} canDelete={isEntryDelete} selectedCompany={selectedCompany} selectedYear={selectedYear} selectedDept={selectedDept} selectState={selectState} />} />
                  <Route
                    path="/SelectCompany"
                    element={
                      <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '100vh',
                        background: 'url("https://images.wallpaperscraft.com/image/single/lines_stripes_blurred_112742_3840x2160.jpg")',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backdropFilter: 'blur(100px)',
                      }}>
                        <SelectForm searchQuery={searchQuery} name={name} onSelectFormSubmit={handleSelectFormSubmit} Company={selectedCompany} Year={selectedYear} Dept={selectedDept} />
                      </div>
                    }
                  />
                </Routes>
              </>
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '100vh', // Ensure full viewport height
                }}
              >
                <LoginForm onLoginSuccess={handleLoginSuccess} />
              </div>
            )}
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
